/** Корень приложения (App.vue): глобальные попапы и общие действия */
export const appRootKey = Symbol('appRoot');
/** Экземпляр PrivatePage для попапов личного кабинета */
export const privatePageHostKey = Symbol('privatePageHost');
